module.exports = __webpack_public_path__ + "static/media/search.0f6b11e7.svg";